import React from "react";
import { Link } from "react-router-dom";
import { PublicHeader } from "@/components/PublicHeader";
import { Icon } from "@/components/kit";
import { history } from "@/api";
import { useI18n } from "@/i18n";

const ICONS = { curtains: "wind", flooring: "grid", wallpaper: "layers", painting: "edit-3" };

export default function MyQuotes() {
  const { t, lang } = useI18n();
  const items = history.list();

  return (
    <div className="min-h-screen bg-paper">
      <PublicHeader />
      <div className="mx-auto max-w-3xl px-5 py-8">
        <h1 className="font-display text-4xl font-semibold text-ink">{t("myq_title")}</h1>
        <p className="mb-8 mt-1 text-[14px] text-mute">{t("myq_sub")}</p>

        {items.length === 0 ? (
          <div className="flex flex-col items-center gap-3 rounded-2xl border border-line bg-white py-20 text-center">
            <Icon name="file-text" size={48} className="text-line-2" />
            <p className="text-[18px] font-semibold text-ink">{t("empty_title")}</p>
            <p className="max-w-sm text-[14px] text-mute">{t("empty_text")}</p>
            <Link to="/" className="mt-2 rounded-full bg-brand px-6 py-2.5 text-[15px] font-semibold text-white">{t("start_btn")}</Link>
          </div>
        ) : (
          <div className="space-y-3">
            {items.map((it) => (
              <Link
                key={it.id}
                to={`/summary/${it.id}`}
                data-testid={`quote-item-${it.id}`}
                className="flex items-center gap-4 rounded-2xl border border-line bg-white p-4 transition-colors hover:border-brand-secondary"
              >
                <span className="flex h-11 w-11 items-center justify-center rounded-xl bg-brand-tertiary">
                  <Icon name={ICONS[it.category] || "file-text"} size={20} className="text-brand" />
                </span>
                <div className="flex-1">
                  <p className="text-[15px] font-semibold text-ink">{t(`cat_${it.category}`)}</p>
                  <p className="text-[13px] text-mute">
                    {new Date(it.created_at).toLocaleDateString(lang, { day: "numeric", month: "long", year: "numeric" })}
                  </p>
                </div>
                <Icon name="chevron-right" size={20} className="text-mute" />
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
